import { Component, OnInit } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from '@uirouter/angular';
import { DataService } from "../../services/data.service";
import { ProjectManagementService } from "../../services/project-management.service";
import { FrontEndService } from "../../services/front-end.service";
import { LogService } from "app/services/log.service";
import { Location } from '@angular/common';

@Component({
    selector: 'app-email-notifications',
    templateUrl: './email-notifications.component.html',
    styleUrls: ['./email-notifications.component.scss']
})
export class EmailNotificationsComponent implements OnInit {
    project_list = [];
    current_user_id:any;
    NotificationData:any;
    all_blocked: boolean = null;
    fullScreenLoader = false;

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public dataService: DataService,
        public project_management_service: ProjectManagementService,
        public front_end_service: FrontEndService,
        private _location: Location,
        private stateService: StateService,
        private logService: LogService
    ) { }

    ngOnInit() {
        this.current_user_id = JSON.parse(localStorage.getItem('currentUser'))["id"];
        this.fullScreenLoader = true;
        this.project_management_service.get_projects((resp) => {
            if(resp.status === true) {
                this.logService.printLog("callBackProjectList.resp " + JSON.stringify(resp));
                this.project_list = resp.data;
                this.user_management_service.getNotification(this.current_user_id, (resp2) => {
                    this.fullScreenLoader = false;
                    if(resp2.status === true) {
                        this.NotificationData = resp2.data;
                        this.all_blocked = this.NotificationData.all_blocked;
                        this.notification_changed(-1, false, false);
                    }
                })
            }
        })
    }

    notification_changed(index, status, clicked) {
        setTimeout(() => {
            this.logService.printLog("All blocked value - " + JSON.stringify(this.all_blocked));

            if(index === -1) {
                if(this.all_blocked) {
                    for(let y = 0; y < this.project_list.length; y++) {
                        this.project_list[y]['notification_blocked'] = true;
                    }
                } else {
                    if(this.project_list.length > 0 && !clicked) {
                        const allSame = this.project_list.every(this.front_end_service.isSameAnswer);
                        if (!allSame) {
                            this.all_blocked = null;
                        }
                        for(let y = 0; y < this.project_list.length; y++) {
                            if (this.NotificationData.blocked_projects.indexOf(this.project_list[y].fip_id) > -1) {
                                this.project_list[y]['notification_blocked'] = true;
                            } else {
                                this.project_list[y]['notification_blocked'] = false;
                            }
                        }
                    } else {
                        for(let y = 0; y < this.project_list.length; y++) {
                            this.project_list[y]['notification_blocked'] = false;
                        }
                    }
                }
            } else {
                const allSame = this.project_list.every(this.front_end_service.isSameAnswer);
                if (allSame) {
                    this.all_blocked = this.project_list[0]['notification_blocked']
                } else {
                    this.all_blocked = null;
                }
            }
        }, 200)
    }

    onSubmit(form) {
        this.logService.printLog("form " + JSON.stringify(form));
        const blocked = [];
        const dataToSend = {};
        for (const k in form) {
            if(k !== 'all_blocked') {
                if (form[k] === true) {
                    blocked.push(parseInt(k));
                }
            }
        }

        dataToSend['blocked_projects'] = blocked;
        dataToSend['all_blocked'] = blocked.length === this.project_list.length;

        this.logService.printLog("To post form - " + JSON.stringify(dataToSend));
        this.fullScreenLoader = true;
        this.user_management_service.saveNotification(dataToSend, this.current_user_id, (resp) => {
            this.fullScreenLoader = false;
            if(resp.status === true) {
                this.front_end_service.back();
            }
        });
    }
}
